import FeatureBoxes from "components/feature-boxes/feature-boxes";

interface FeaturesProp {
  boxes: {
    Heading: string;
    Content: string;
    Divider: boolean;
    FeatureBoxes: {
      Content: string;
      Media: any;
      Title: string;
      id: number;
    }[];
    Title: string;
    id?: number;
  };
}

const Features: React.FC<FeaturesProp> = ({ boxes }) => (
  <div className="features">
    <div className="container container--small">
      <div className="features__inner">
        {boxes.Heading && <h2 className="features__heading h4">{boxes.Heading}</h2>}
        <FeatureBoxes boxes={boxes} headingLevel={boxes.Heading ? "h3" : "h2"} />
      </div>
    </div>
  </div>
);

export default Features;
